var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"border":"1px solid var(--border)","border-radius":"5px","margin-bottom":"10px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }